'use client';

import { useEffect } from 'react';

export function FormAssemblyStyles() {
  useEffect(() => {
    const links = document.querySelectorAll('link[rel="preload"]');
    links.forEach((link) => {
      (link as HTMLLinkElement).rel = 'stylesheet';
    });
  }, []);

  return (
    <>
      <link
        href='https://www.tfaforms.com/dist/form-builder/5.0.0/wforms-layout.css?v=573'
        rel='preload'
        as='style'
        type='text/css'
        onLoad={(e) => {
          (e.target as HTMLLinkElement).rel = 'stylesheet';
        }}
      />
      <link
        href='https://www.tfaforms.com/uploads/themes/theme-63874.css'
        rel='preload'
        as='style'
        type='text/css'
        onLoad={(e) => {
          (e.target as HTMLLinkElement).rel = 'stylesheet';
        }}
      />
      <link
        href='https://www.tfaforms.com/dist/form-builder/5.0.0/wforms-jsonly.css?v=573'
        rel='preload'
        as='style'
        type='text/css'
        title='This stylesheet activated by javascript'
        onLoad={(e) => {
          (e.target as HTMLLinkElement).rel = 'stylesheet';
        }}
      />
      <noscript>
        <link
          href='https://www.tfaforms.com/dist/form-builder/5.0.0/wforms-layout.css?v=573'
          rel='stylesheet'
          type='text/css'
        />
        <link href='https://www.tfaforms.com/uploads/themes/theme-63874.css' rel='stylesheet' type='text/css' />
        <link
          href='https://www.tfaforms.com/dist/form-builder/5.0.0/wforms-jsonly.css?v=573'
          rel='stylesheet'
          type='text/css'
          title='This stylesheet activated by javascript'
        />
      </noscript>
    </>
  );
}
